import React from 'react';
import SymbolImage from './SymbolImage';
import { RuleResultSpecSymbol } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

interface SpecCheckDetailsSymbolProps {
    ruleResult: RuleResultSpecSymbol;
}

const SpecCheckDetailsSymbol: React.FC<SpecCheckDetailsSymbolProps> = ({
    ruleResult,
}) => {
    return (
        <table className="spec-check-details-text-changes-new">
            <thead>
                <tr></tr>
            </thead>
            <tbody>
                <tr>
                    <td>Symbol</td>
                    <td>
                        <SymbolImage
                            symbolId={ruleResult.output_data.symbol_id}
                        />
                    </td>
                </tr>
                {ruleResult.output_data.symbol_height && (
                    <tr>
                        <td>Size</td>
                        <td className="size">
                            {ruleResult.output_data.detected_symbols.map(
                                (dectectedSymbol) => {
                                    const symbolHeightIsValid = true;
                                    ruleResult.output_data.symbol_height &&
                                        (!ruleResult.output_data.symbol_height
                                            .min ||
                                            dectectedSymbol.dimensions.height >=
                                                ruleResult.output_data
                                                    .symbol_height.min) &&
                                        (!ruleResult.output_data.symbol_height
                                            .max ||
                                            dectectedSymbol.dimensions.height <=
                                                ruleResult.output_data
                                                    .symbol_height.max);

                                    return (
                                        <>
                                            {`${dectectedSymbol.dimensions.height.toFixed(
                                                2,
                                            )} mm`}
                                            <FontAwesomeIcon
                                                icon={
                                                    symbolHeightIsValid
                                                        ? faCheck
                                                        : faXmark
                                                }
                                                color={
                                                    symbolHeightIsValid
                                                        ? 'green'
                                                        : 'red'
                                                }
                                                style={{ fontSize: '1.4em' }}
                                            />
                                        </>
                                    );
                                },
                            )}
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default SpecCheckDetailsSymbol;
